export { default as dispatchCreate } from './DispatchCreate'
export { default as dispatchEdit } from './DispatchEdit'
export { default as location } from './Location'
export { default as reference } from './Reference'
export { default as role } from './Role'
export { default as stopover } from './StopOver'
export { default as transit } from './Transit'
export { default as ratesCreate } from './RateCreate'
export { default as ratesEdit } from './RateEdit'
export { default as itemCreate } from './ItemCreate'
export { default as arrivalnotificationEdit } from './ArrivalNotificationEdit'
export { default as quoteEdit } from './QuoteEdit'
export { default as localCreate } from './LocalCreate';
export { default as localEdit } from './LocalEdit';
export { default as maritimeCreate } from './MaritimeCreate';
export { default as maritimeEdit } from './MaritimeEdit';
export { default as aamxCreate } from './AamxCreate';
export { default as aamxEdit } from './AamxEdit';
export { default as landCreate } from './LandCreate';
export { default as landEdit } from './LandEdit';
export { default as instructionletterCreate } from './InstructionLetterCreate';
export { default as instructionletterEdit } from './InstructionLetterEdit';
export { default as containersCreate } from './ContainersCreate';
export { default as containersEdit } from './ContainersEdit';
export { default as profitandlosesEdit } from './ProfitAndLosesEdit';
export { default as vehicleCreate } from './VehicleCreate';
export { default as vehicleEdit } from './VehicleEdit';
export { default as driver } from './Driver';
export { default as termsandconditionsEdit } from './TermsAndConditionsEdit';
export { default as termsandconditionsCreate } from './TermsAndConditionsCreate';


// WEBPACK FOOTER //
// ./src/forms/index.js